export default class LDTutorialModal {
    constructor() {
        this.tutorialModal = document.querySelector('.jsTutorialModal');

        if (this.tutorialModal) {
            this.tutorialModalClose = [
                ...this.tutorialModal.querySelectorAll('.jsTutorialModalClose'),
            ];

            this.iframe = this.tutorialModal.querySelector(
                '.jsTutorialModalIframeParent iframe',
            );

            this.video = this.tutorialModal.querySelector(
                '.jsTutorialModalVideo',
            );

            this.events();
        }
    }

    events() {
        this.checkAndShowModalIfNeeded();

        if (this.tutorialModalClose.length) {
            this.tutorialModalClose.forEach((btn) =>
                btn.addEventListener('click', this.closeModal.bind(this)),
            );
        }
    }

    checkAndShowModalIfNeeded() {
        const showTutorial = this.tutorialModal.dataset.showTutorial;
        const self = this;

        if (showTutorial) {
            window.setTimeout(() => {
                self.tutorialModal.showModal();
            }, 1000);
        }
    }

    closeModal() {
        if (this.iframe) {
            const getSrc = this.iframe.src;
            this.iframe.src = getSrc;
        }

        if (this.video) {
            this.video.pause();
        }

        this.tutorialModal.close();
    }
}
